import React from 'react'
import {loadRoute, pinRoute} from 'lib/api/routes'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ChooseDeviceStep} from './ChooseDeviceStep'
import {S2DMobileView} from './S2DMobileView'
import {userAgentIsIphone, userAgentIsAndroid} from 'lib/mobileDeviceChecks'
import {buildQueryString} from 'lib/utils'
import _ from 'lodash'
import {MobileAppFlowContainer} from './flows/MobileAppFlow'
import {GarminFlow} from './flows/GarminFlow'
import {WahooFlow} from './flows/WahooFlow'
import {OtherFlow} from './flows/OtherFlow'

const Flows = {
  'iphone': MobileAppFlowContainer,
  'android': MobileAppFlowContainer,
  'garmin': GarminFlow,
  'wahoo': WahooFlow,
  'other': OtherFlow
}

export class SendToDeviceV2 extends React.PureComponent {
  constructor (props) {
    super(props)
    const {postSignin, selectedDevice} = this.props.location.query
    const skipChooseDevice = postSignin && selectedDevice
    this.state = {
      step: skipChooseDevice ? 2 : 1,
      selectedDevice: selectedDevice
    }
    if (postSignin) {
      const filteredQuery = buildQueryString(_.omit(this.props.location.query, 'postSignin'))
      const withoutSigninParam = filteredQuery
        ? `?${filteredQuery}`
        : ''

      browserHistory.replace(window.location.pathname + withoutSigninParam + window.location.hash)
    }
  }

  componentDidMount () {
    const {loadRoute, pinRoute, route} = this.props
    const {routeId} = this.props.params
    if (!route) {
      loadRoute(routeId)
    } else {
      pinRoute(route.id, {source: 's2d'})
      this._didPin = true
    }
  }

  componentDidUpdate () {
    const {route, pinRoute} = this.props
    if (route && !this._didPin) {
      pinRoute(route.id, {source: 's2d'})
      this._didPin = true
    }
  }

  onChangeDevice = (selectedDevice) => {
    this.setState({selectedDevice})
  }

  onConfirmDevice = (deviceOverride) => {
    if (deviceOverride) {
      this.setState({step: 2, selectedDevice: deviceOverride})
    } else {
      this.setState({step: 2})
    }
  }

  onNext = () => {
    this.setState({step: this.state.step + 1})
  }

  onPrev = () => {
    this.setState({step: this.state.step - 1})
  }

  render () {
    const {route, params} = this.props
    const {selectedDevice, step} = this.state

    // bail out if we're being loaded on a mobile device without the app installed
    if (userAgentIsIphone()) {
      return <S2DMobileView platform='iphone' routeId={params.routeId} route={route} />
    }

    if (userAgentIsAndroid()) {
      return <S2DMobileView platform='android' routeId={params.routeId} route={route} />
    }

    const subtitle = <span>
      Sending route:{' '}
      <a href={`/routes/${params.routeId}`}>{route && route.name}</a>
    </span>

    // a little bit of a hack, but waaaaaay cleaner than trying to bring in <Helmet />
    route && route.name && (document.title = `Sending '${route.name}' · Ride with GPS`)

    if (step > 1) {
      const Flow = Flows[selectedDevice]
      return <Flow
        selectedDevice={selectedDevice}
        step={step}
        onNext={this.onNext}
        onPrev={this.onPrev}
        route={route}
        routeId={params.routeId}
        subtitle={subtitle} />
    }

    return (
      <ChooseDeviceStep
        route={route}
        routeId={params.routeId}
        subtitle={subtitle}
        selectedDevice={selectedDevice}
        onChangeDevice={this.onChangeDevice}
        onConfirmDevice={this.onConfirmDevice} />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  route: state.routes.get(parseInt(ownProps.params.routeId, 10)),
  loggedIn: state.currentUser.id !== undefined
})

const mapDispatchToProps = {
  loadRoute,
  pinRoute
}

export const SendToDeviceV2Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(SendToDeviceV2)
